import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CloseOutlined, FolderOutlined, RightOutlined } from "@ant-design/icons";
/**
 * Simple breadcrumbs with arrows and a home icon.
 */ function Breadcrumb({ path, closeable = false, onClose }) {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(FolderOutlined, {}),
            "\xa0\xa0",
            path.map((item, index)=>/*#__PURE__*/ _jsxs("span", {
                    children: [
                        item,
                        "\xa0",
                        index < path.length - 1 && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(RightOutlined, {
                                    style: {
                                        fontSize: 10,
                                        opacity: 0.65
                                    }
                                }),
                                "\xa0"
                            ]
                        })
                    ]
                }, index)),
            !!closeable && /*#__PURE__*/ _jsx(CloseOutlined, {
                onClick: onClose,
                style: {
                    cursor: "pointer"
                }
            })
        ]
    });
}
export { Breadcrumb };
